import { createSvgComponent } from "../../icon/createSvgComponent";
import WelloBizLogo from "@core/icon/assets/wello-biz-logo.svg";
export default createSvgComponent(WelloBizLogo);